/**
 * section-ls-showroom-video.js
 * Click-to-play handler for both uploaded (native) and external embed videos.
 * Same pattern as section-ls-media-cta.js, scoped to .lssv__ markup.
 */

document.querySelectorAll('.lssv__video-wrapper').forEach((wrapper) => {
  const playBtn = wrapper.querySelector('.lssv__play-btn');
  if (!playBtn) return;

  const videoType = wrapper.dataset.videoType;

  playBtn.addEventListener('click', () => {
    if (videoType === 'native') {
      const videoEl = wrapper.querySelector('.lssv__native-video');
      const poster = wrapper.querySelector('.lssv__poster');
      if (!videoEl) return;

      if (poster) poster.style.display = 'none';
      playBtn.style.display = 'none';
      videoEl.style.display = 'block';
      videoEl.play();
    } else if (videoType === 'embed') {
      const embedUrl = wrapper.dataset.videoEmbedUrl;
      if (!embedUrl) return;

      const iframe = document.createElement('iframe');
      iframe.src = embedUrl;
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.className = 'lssv__iframe';

      wrapper.innerHTML = '';
      wrapper.appendChild(iframe);
    }
  });
});
